import React from 'react';
import { Phone } from 'lucide-react';
import { COMPANY } from '../mock';

const StickyMobileCTA = () => {
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 shadow-lg">
      <a
        href={`tel:${COMPANY.phoneRaw}`}
        className="flex items-center justify-center gap-2 py-4 text-[#0d3d5e] font-semibold"
      >
        <Phone className="w-5 h-5" /> Call {COMPANY.phone}
      </a>
    </div>
  );
};

export default StickyMobileCTA;
